// Shared price maths for a (service, massageType) pair.
// Tolerant of numeric and string keys in priceAdjustmentMap, because the map is
// free-form JSON from the backoffice and both shapes exist in production.

export function adjustmentFor(service, massageType) {
    if (!service || !massageType) return 0

    const map = massageType.priceAdjustmentMap
    if (map && typeof map === 'object') {
        const adjustment = map[service.duration] ?? map[String(service.duration)]
        if (adjustment !== undefined && adjustment !== null) return adjustment
    }

    return massageType.priceAdjustment || 0
}

export function priceFor(service, massageType) {
    if (!service) return 0
    if (!massageType) return service.price
    return service.price + adjustmentFor(service, massageType)
}

// The durations a massage type can actually be booked for.
// No priceAdjustmentMap => flat pricing => every duration is available.
export function durationsFor(massageType, services) {
    const list = services || []
    if (!massageType) return list

    const map = massageType.priceAdjustmentMap
    if (!map || typeof map !== 'object') return list

    return list.filter((s) => s.duration in map || String(s.duration) in map)
}
